/**
 * Clone Int32 value
 *
 * @param {import('./Int32Type.js').BrandedInt32} value - Value to clone
 * @returns {import('./Int32Type.js').BrandedInt32} Cloned value
 */
export function clone(value) {
	return /** @type {import('./Int32Type.js').BrandedInt32} */ (value);
}
